function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_357",
  "data-name": "Path 357",
  d: "M1307.49,708.395a9.1,9.1,0,1,1-9.1-9.1A9.092,9.092,0,0,1,1307.49,708.395Zm1.3,0A10.395,10.395,0,1,1,1298.395,698,10.393,10.393,0,0,1,1308.789,708.395Zm-10.395,2.239a7.734,7.734,0,0,0,4.769-1.5l.429.383a6.247,6.247,0,0,1-10.395,0l.429-.383A7.734,7.734,0,0,0,1298.395,710.633Zm-4.327-4.967a1.307,1.307,0,1,1,1.3,1.169A1.233,1.233,0,0,1,1294.068,705.666Zm6.055,0a1.307,1.307,0,1,1,1.3,1.169A1.242,1.242,0,0,1,1300.123,705.666Z",
  transform: "translate(-1288 -698)",
  fill: "current",
  fillRule: "evenodd"
});

function SvgEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.789,
    height: 20.789,
    viewBox: "0 0 20.789 20.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.96520ec5.svg";
export { ForwardRef as ReactComponent };